import { render, staticRenderFns } from "./iconAmericanFlag.vue?vue&type=template&id=8356b0e0&scoped=true"
import script from "./iconAmericanFlag.vue?vue&type=script&lang=js"
export * from "./iconAmericanFlag.vue?vue&type=script&lang=js"
import style0 from "./iconAmericanFlag.vue?vue&type=style&index=0&id=8356b0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8356b0e0",
  null
  
)

export default component.exports